import enginer from '../../../../../assets/icons/enginer.svg';
import clock from '../../../../../assets/icons/clock.svg';
import confirm from '../../../../../assets/icons/confirm.svg';
import schedule from '../../../../../assets/icons/schedule.svg';
import fuel from '../../../../../assets/icons/fuel.svg';
import success from '../../../../../assets/icons/success.svg';

export const statusItems = [
  {
    id: 1,
    icon: enginer,
    text: 'Pedido recebido',
  },
  {
    id: 2,
    icon: clock,
    text: 'Em análise',
  },
  {
    id: 3,
    icon: schedule,
    text: 'Agendado',
  },
  {
    id: 4,
    icon: confirm,
    text: 'Confirmado',
  },
  {
    id: 5,
    icon: fuel,
    text: 'Rota de entrega',
  },
  {
    id: 6,
    icon: success,
    text: 'Entregue',
  },
];
